import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../../types/configColumns2";
import { momentDtoToLocalStringByCulture } from "../../../aplUtils/dateHelper";
import { Culture } from "../../../types/culture";
import { resources } from "../../../translations/resources";
import { PrintHistoryStatus } from "../../../types/printHistoryStatus";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { PrintHistoryFooter } from "../../../types/printHistoryFooter";
import { truncateString } from "../../../aplUtils/stringUtills";
import { Guid } from "guid-typescript";
import { Tooltip } from "react-tooltip";
import React from "react";
import { renderToString } from "react-dom/server";
import { showModalWithPalletsByGuid, closeModalRedux as closeModal } from "../../../redux/slices/modalPallets2.feature";
import { onSetModalShown } from "../../../redux/slices/palletCache.feature";
import { ModalType } from "./types/modalType";
import { translateString } from "../../../translations/gridTranslationHelper";
import { getReprintLabelsRedux, getReprintPrintersRedux } from "../../../redux/slices/reprint.feature";

const getPrintHistoryColumns = (siteId: number, culture: Culture, dispatch: Dispatch<AnyAction>, reprintPerm: boolean) => {
    const translations = resources[culture ?? "en-GB"].translation.main;
    const renderStatus = (printStatusId: number, culture: Culture) => {
        if (printStatusId < 1) return translations["error" as any];
        else if (printStatusId === 1) return translations["success" as any];
        return (printStatusId as PrintHistoryStatus).toString();
    };

    const setModalVisibility = (modalType: ModalType, palletId: string) => {
        if (modalType === ModalType.None) {
            dispatch(closeModal());
        }
        dispatch(
            showModalWithPalletsByGuid({
                pallets: [Guid.parse(palletId)],
                modalType: ModalType.Reprint,
                callerModalType: ModalType.PrintHistory
            }) as any
        );
        dispatch(onSetModalShown(modalType));
    };

    const generateBobTooltipJsx = function (input: string): JSX.Element {
        const tooltipId = Guid.create();
        return (
            <React.Fragment>
                <Tooltip id={`bob-tooltip-${tooltipId}`} html={renderToString(<span>{input}</span>)} />
                <span data-tooltip-delay-hide={666} data-tooltip-id={`bob-tooltip-${tooltipId}`}>
                    {truncateString(input, 33).truncated}
                </span>
            </React.Fragment>
        );
    };

    let columns: ConfigColumns2[] = [];
    columns = [
        { data: "printId", visible: false, width: "0px", title: "printId" },
        {
            data: "printHistoryStatusId",
            className: "nowrap",
            width: "20%",
            title: "status",

            render: function (data: PrintHistoryFooter, type: ColumnFilterOrDisplayType | undefined) {
                return renderStatus(data.printHistoryStatusId, culture);
            },
            visible: true
        },
        { data: "lineDescription", className: "nowrap", width: "20%", title: "line", visible: true },
        { data: "workOrder", className: "nowrap", width: "20%", title: "workOrder", visible: true },
        { data: "sscc", className: "nowrap", width: "20%", title: "sscc", visible: true },
        { data: "sequenceNo", className: "nowrap", width: "20%", title: "rank", visible: true },
        {
            data: "rowCreatedTimeStamp",
            className: "nowrap",
            width: "20%",
            title: "time",

            render: function (data: PrintHistoryFooter, type: ColumnFilterOrDisplayType | undefined) {
                return type === "display"
                    ? momentDtoToLocalStringByCulture(data.rowCreatedTimeStamp, culture)
                    : data.rowCreatedTimeStamp.toString();
            },
            visible: true
        },
        { data: "printerName", className: "nowrap", width: "50%", title: "printer", visible: true },
        { data: "materialSapCode", className: "nowrap", width: "20%", title: "material", visible: true },
        {
            data: "failureText",
            className: "nowrap",
            width: "20%",
            title: "error",
            visible: true,
            render: function (data: PrintHistoryFooter, type: ColumnFilterOrDisplayType | undefined) {
                return type === "display" ? generateBobTooltipJsx(data.failureText) : data.failureText;
            }
        }
    ];
    if (reprintPerm) {
        columns.push({
            data: "palletId",
            className: "nowrap",
            width: "5%",
            title: "print",

            render: function (data: PrintHistoryFooter, type: ColumnFilterOrDisplayType | undefined) {
                return type === "display" ? (
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                            setModalVisibility(ModalType.Reprint, data.palletId);
                            dispatch(getReprintLabelsRedux() as any);
                            dispatch(
                                getReprintPrintersRedux({
                                    siteId: data.siteId,
                                    departmentId: 0,
                                    lineId: 0,
                                    groupByPrinterId: true,
                                    offline: true
                                }) as any
                            );
                        }}
                    >
                        {translateString("print", culture)}
                    </button>
                ) : (
                    ""
                );
            },
            visible: true
        });
    };
    return columns;
};

export { getPrintHistoryColumns };
